module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-result-sub"
  }, [_c('h4', [_vm._v(_vm._s(_vm.type))]), _vm._v(" "), _c('table', {
    staticClass: "tbl-result2"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.filteredData.leiloes), function(leilao) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.semAno(leilao.data)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leilao.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(leilao.vendidos))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.an(leilao.percentualVenda)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.an(leilao.percentualFipe)) + "%")])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n        Médias mês vendidos: "), _c('strong', [_vm._v(_vm._s(_vm.an(_vm.filteredData.mediaPeriodoVendidos)) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n        Médias mês FIPE: "), _c('strong', [_vm._v(_vm._s(_vm.an(_vm.filteredData.mediaPeriodoFipe)) + "%")])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Vendidos")]), _vm._v(" "), _c('th', [_vm._v("% Venda")]), _vm._v(" "), _c('th', [_vm._v("% FIPE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ab4eaaf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/relatorios-basicos/components/media-fipe-comitentes/table.vue
// module id = 1669
// module chunks = 18